<template>
  <div v-if="tabsWithBadge.length > 0">
    <TabsNavigation :tabs="tabsWithBadge" class="my-6" />

    <QuotationInformation
      v-if="currentTab === 'quotations' && claim.quotation"
      :quotation="claim.quotation"
      class="mt-6"
    />

    <InvoiceInformation v-if="currentTab === 'invoices' && claim.invoice" :invoice="claim.invoice" class="mt-6" />

    <VoucherInformation v-if="currentTab === 'voucher' && claim.voucher" :voucher="claim.voucher" class="mt-6" />
  </div>
</template>

<script>
import QuotationInformation from "@/components/claim/details/quotation/QuotationInformation.vue";
import InvoiceInformation from "@/components/claim/details/invoice/InvoiceInformation.vue";
import VoucherInformation from "@/components/claim/details/voucher/VoucherInformation.vue";
import { TabsNavigation } from "@estaly/ui";

export default {
  components: {
    TabsNavigation,
    QuotationInformation,
    InvoiceInformation,
    VoucherInformation,
  },

  props: {
    claim: {
      type: Object,
      required: true,
    },
  },

  watch: {
    currentTab: {
      immediate: true,
      handler(resolvedTab) {
        if (resolvedTab && resolvedTab !== this.$route.query.tab) {
          this.$router.replace({ query: { ...this.$route.query, tab: resolvedTab } });
        }
      },
    },
  },

  computed: {
    currentTab() {
      const requestedTab = this.$route.query.tab;
      const availableTabs = this.tabsWithBadge.map((tab) => tab.name);

      if (availableTabs.length === 0) return null;
      if (requestedTab && availableTabs.includes(requestedTab)) return requestedTab;
      return availableTabs[0];
    },

    tabsWithBadge() {
      const availableTabs = [];

      if (this.claim?.quotation) {
        const tab = {
          name: "quotations",
          displayName: "Devis",
          query: { tab: "quotations" },
        };
        if (this.claim.quotation.approvalStatus === "to_be_approved") {
          tab.badge = {
            text: "!",
            class: "bg-yellow-100 text-yellow-800",
          };
        }

        availableTabs.push(tab);
      }

      if (this.claim?.invoice) {
        const tab = {
          name: "invoices",
          displayName: "Facture",
          query: { tab: "invoices" },
        };

        if (this.claim.invoice.approvalStatus === "to_be_approved") {
          tab.badge = {
            text: "!",
            class: "bg-yellow-100 text-yellow-800",
          };
        }

        availableTabs.push(tab);
      }

      if (this.claim?.voucher) {
        availableTabs.push({
          name: "voucher",
          displayName: "Avoirs",
          query: { tab: "voucher" },
        });
      }

      return availableTabs;
    },
  },
};
</script>
